import { render, staticRenderFns } from "./PanelTrabajador.vue?vue&type=template&id=0743fa46"
import script from "./PanelTrabajador.vue?vue&type=script&lang=js"
export * from "./PanelTrabajador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports